import {
  columnSizingFeature,
  columnVisibilityFeature,
  rowSortingFeature,
  tableFeatures,
  useTable as useReactTable,
  type ColumnDef as TanStackColumnDef,
  type RowData
} from "@tanstack/react-table"

export const tableFeatureSet = tableFeatures({
  columnSizingFeature,
  columnVisibilityFeature,
  rowSortingFeature
})

export type ColumnDef<TData extends RowData, TValue = unknown> =
  TanStackColumnDef<typeof tableFeatureSet, TData, TValue>

type TableState<T extends RowData> = {
  data: T[]
  columns: ColumnDef<T>[]
}

export function useTable<T extends RowData>({ data, columns }: TableState<T>) {
  const table = useReactTable({
    data,
    columns,
    features: tableFeatureSet
  })

  return {
    table
  }
}
